import "./notification-provider.css";

import {
	Notification,
	NotificationGroup,
} from "@tql/ui-components-react/kendo/notification";

import { useNotifications } from "~/shared/hooks/use-notifications.ts";

export function NotificationProvider() {
	const { notifications, closeNotification } = useNotifications();

	// Scoped notifications are rendered inline by their owning feature (e.g. the
	// shipment-management error banner), so they are excluded from global toasts.
	const toastNotifications = notifications.filter(
		(notification) => !notification.scope,
	);

	return (
		<NotificationGroup
			style={{
				position: "fixed",
				right: 16,
				bottom: 16,
				alignItems: "flex-start",
				flexWrap: "wrap-reverse",
				zIndex: 11_000,
			}}
		>
			{toastNotifications.map((notification) => (
				<div key={notification.id} className={"notification-slide-enter"}>
					<Notification
						closable={notification.closable}
						onClose={() => closeNotification(notification.id)}
						style={
							notification.type === "none" ? { overflow: "visible" } : undefined
						}
						type={{
							style: notification.type,
							icon: notification.type !== "none",
						}}
					>
						<span>{notification.message}</span>
					</Notification>
				</div>
			))}
		</NotificationGroup>
	);
}
